import { isEmpty } from 'lodash';

export function isErrorsEmpty(arr: Array<any>) {
    for (const item of arr) {
        if (!isEmpty(item)) {
            return false;
        }
    }
    return true;
}

/**
 * Gets the current subdomain from window.location.hostname
 * @returns The subdomain string (e.g., "orner" from "orner.cargozone.ai") or undefined if no subdomain
 */
export function getCurrentSubdomain(): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }
    
    const hostname = window.location.hostname;
    
    // Handle localhost and IP addresses
    if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        return undefined;
    }
    
    // Extract subdomain from hostname (e.g., "orner.cargozone.ai" -> "orner")
    const parts = hostname.split('.');
    
    // If we have at least 3 parts (subdomain.domain.tld), return the first part
    // For 2 parts (domain.tld), return undefined as there's no subdomain
    if (parts.length >= 3) {
        return parts[0].toLowerCase();
    }
    
    return undefined;
}

/**
 * Checks if the current subdomain is one of the allowed subdomains
 * Also allows localhost in development mode for testing
 * @param allowedSubdomains Array of allowed subdomain strings
 * @returns true if current subdomain is in the allowed list, or if on localhost in development mode
 */
export function isAllowedSubdomain(allowedSubdomains: string[]): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    
    const hostname = window.location.hostname;
    
    // Allow localhost in development mode (for local testing)
    const isDevelopment = hostname === 'localhost' || 
                         hostname === '127.0.0.1' || 
                         /^127\.0\.0\.\d+$/.test(hostname) ||
                         /^localhost(:\d+)?$/.test(hostname);
    
    if (isDevelopment) {
        return true;
    }
    
    const currentSubdomain = getCurrentSubdomain();
    if (!currentSubdomain) {
        return false;
    }
    
    return allowedSubdomains.some(
        allowed => allowed.toLowerCase() === currentSubdomain.toLowerCase()
    );
}

export const camalize = (str: string) => {
    return str.replace(/^([A-Z])|[\s-_]+(\w)/g, function (match, p1, p2, offset) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
    });
};
